// extracted by mini-css-extract-plugin
export default {"imprint":"Imprint_imprint__PrgN2"};